import React, {Component} from 'react'
import './styles.css'
import {apiEmployee} from '../../services/apiamrg'
import Header from '../../components/header'
import Skeleton from '../../components/skeleton'
import {Link, useHistory, Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import {PRECISA_LOGAR, NOME_EMPRESA} from '../../config'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch, faCoffee, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const estadoInicial = {
    name: '',
    terminais: [],
    seaports: [],
    loading: true,
    redirect: false
}

function filtroPortos(chave){
    return function filter(valor){
        return valor.id === chave
    }
}

class Terminais extends Component {
    
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getNews()
        this.getSeaports()
    }

    getSeaports = async () => {
        await apiEmployee.post(`getSeaports.php`, {
            token: this.props.token
        })
        .then(
            async response => { 
                await this.setState({seaports: response.data})
                await this.setState({loading: false})
            },
            response => {this.erroApi(response)}
        )
    }


    
   getNews = async () => {
    await apiEmployee.post(`getTerminais.php`, {
        token: this.props.token
    }).then(
        async response => { 
            await this.setState({terminais: response.data})
            await this.setState({loading: false})
        },
        response => {this.erroApi(response)}
    
        )
    } 

    erroApi = async () => {
        alert(PRECISA_LOGAR)
        await this.setState({redirect: true})
    }

    deleteTerminal = async (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui text-center'>
                  <h1>{NOME_EMPRESA}</h1>
                  <p>Deseja remover este Terminal? ({nome}) </p>
                  <button 
                      style={{marginRight: 5}}
                      className="btn btn-success w-25"
                      onClick={
                          async () => {
                              onClose()
                          }
                      }
                  >
                      Não
                  </button>
                  <button 
                      style={{marginRight: 5}}
                      className="btn btn-danger w-25"
                      onClick= {
                            async () => {
                                await apiEmployee.post(`deleteTerminal.php`, {
                                    token: this.props.token,
                                    id_terminal: id
                                }).then(
                                    async response => { 
                                        if(response.data == true){
                                            alert('Terminal removido!')
                                            document.location.reload()
                                        }
                                    },
                                    async response => {
                                        this.erroApi(response)
                                    }
                                )
                                onClose()
                            }    
                        }
                           
                    >
                      Sim
                  </button>
                </div>
              )
            }
        })
    }

    filtroSeaport = (portos) => parseInt(portos.id) === 6

    render(){
        
        return (

            <div>
                {this.state.loading &&
                    <Skeleton />
                }

                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }

                {!this.state.loading &&
                <div>
                <section>
                    <Header voltar/>
                    
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="page-breadcrumb">
                                    <h2 id='titulo'>Terminais</h2>
                                </div>
                            </div>
                        </div>
                    
                </section>

                <div className="row">
                    <div className="col-2"></div>
                    <div className="col-8 text-center">
                        <Link to={{pathname: `/admin/addterminal/0`}}><button className="btn btn-success"  >Adicionar</button></Link>
                    </div>
                    <div className="col-2"></div>                            
                </div>
                    
            

                <div className="row" id="product-list">
                    <div className="col-2"></div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 mix all dresses bags">
                        <div className="single-product-item">
                            <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right">
                                    <span className="subtituloships">Porto</span>   
                                </div>
                                <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 text-right">
                                    <span className="subtituloships">Name</span>
                                </div>
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-right">
                                    <span className="subtituloships"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-2"></div>
                </div>

                <div id="product-list">
                        {this.state.terminais.map((feed,index) => (
                             <div key={feed.id} className="row">
                                <div className="col-2"></div>
                                <div className={index % 2 == 0 ? "col-lg-8 col-md-8 col-sm-8 mix all dresses bags par" : "col-lg-8 col-md-8 col-sm-8 mix all dresses bags itemLista impar"}>
                                    <div className="single-product-item">
                                        <div className="row">
                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right">
                                            <Link 
                                                    to={{
                                                        pathname: `/admin/addterminal/${feed.id}`, 
                                                        state: {terminal: {...feed}}
                                                    }}
                                                >
                                                {this.state.seaports.filter(filtroPortos(feed.porto)).map(porto => (
                                                    <h6>{porto.name}</h6>
                                                ))}
                                                </Link>
                                            </div>
                                            <div className='col-1'></div>
                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right">
                                                <Link 
                                                    to={{
                                                        pathname: `/admin/addterminal/${feed.id}`, 
                                                        state: {terminal: {...feed}}
                                                    }}
                                                >
                                                    <p>{feed.nome}</p>
                                                </Link>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 text-left iconelixo" onClick={ () => this.deleteTerminal(feed.id , feed.nome)} type='button'>
                                          <FontAwesomeIcon icon={faTrashAlt} />
                                        </div>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2"></div>
                            </div>
                        ))}
                </div>
               </div>
            }
            </div>
        )
        
    }
}

const mapStateToProps = ({user, servidor}) => {
    return{
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Terminais)